import { defineComponent } from 'vue';
export default defineComponent({
    name: 'SearchOptionItem',
    props: {
        button: Object,
    },
});
